<template>
  <div>
    <app-navbar/>
    <v-content>
        <v-container fluid>
           <v-layout row pb-2>
            <v-flex xs12>
              <v-card class="card--flex-toolbar">
                <v-toolbar card prominent>
                  <v-toolbar-title class="body-2 grey--text">CLIENTS</v-toolbar-title>
                  <v-spacer />
                    <v-text-field label="Rechercher un client..." solo v-model="search" append-icon="search" ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn :disabled="this.loading" primary @click="()=>openVendeurDialog(null)">Nouveau</v-btn>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card  v-for="vendeur in displayedVendors" :key="vendeur.id" class="vendeur" @click="openVendeurDialog(vendeur)">
                  <div>
                    <v-icon>person</v-icon> <span class="font-weight-bold">{{vendeur.prenom + " " + vendeur.nom}}</span>
                  </div>
                  <div>
                    <a class="link" :href="`tel:${vendeur.tel}`" ><v-icon>phone</v-icon>  {{vendeur.tel}}</a>
                  </div>
                  <div>
                    <a class="link" :href="`mailto:${vendeur.mail}`" ><v-icon>email</v-icon>  {{vendeur.mail}}</a>
                  </div>
                </v-card>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
    </v-content>
    <v-dialog width='400px' v-model="vendeurDialog" :key="vendeurDialog" :persistent="edit"><v-card>
        <div v-if="this.vendeur!=null">
          <v-card-title class="text-uppercase secondary--text">Vendeur<v-spacer/><v-btn color="red" dark @click="deleteVendeur(vendeur.id)" v-if="this.vendeur.id!==undefined">Supprimer</v-btn></v-card-title>
          <v-card-text>
            <v-form ref="form">
            <v-layout row wrap>
              <v-flex xs12 p-2><v-text-field :disabled="!this.edit || this.loading" :rules="inputRules['isNotNull']" label="Nom" prepend-icon="person" v-model="vendeur.nom"></v-text-field></v-flex>    
              <v-flex xs12 p-2><v-text-field :disabled="!this.edit || this.loading" :rules="inputRules['isNotNull']" label="Prénom" prepend-icon="person" v-model="vendeur.prenom"></v-text-field></v-flex>    
              <v-flex xs12><v-text-field :disabled="!this.edit || this.loading" :rules="inputRules['isNotNull']" label="Tel." prepend-icon="phone" v-model="vendeur.tel" type="number"></v-text-field></v-flex>    
              <v-flex xs12><v-text-field :disabled="!this.edit || this.loading" label="E-mail" prepend-icon="email" :value="vendeur.mail" type="e-mail"></v-text-field></v-flex>
              <v-flex xs12><v-text-field :disabled="!this.edit || this.loading" label="Adresse" prepend-icon="home_work" v-model="vendeur.adresse"></v-text-field></v-flex>  
              <v-flex xs12><v-text-field :disabled="!this.edit || this.loading" label="Code postal" prepend-icon="home_work" v-model="vendeur.code_postal"></v-text-field></v-flex>  
              <v-flex xs12><v-text-field :disabled="!this.edit || this.loading" label="Ville" prepend-icon="home_work" v-model="vendeur.ville"></v-text-field></v-flex>  
              <v-flex xs12><v-select :disabled="!this.edit || this.loading" :rules="inputRules['isNotNull']" label="Origine" prepend-icon="info" v-model="vendeur.origine" :items="this.values['origines']"></v-select></v-flex>  
            </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions><v-btn v-if="this.edit" :disabled="this.loading" @click="saveEdit()">Enregistrer</v-btn><v-btn :disabled="this.loading"  v-if="!this.edit" @click="edit=true">Modifier</v-btn><v-btn :disabled="this.loading" @click="closeDialog()">Retour</v-btn></v-card-actions>
        </div>
    </v-card></v-dialog>

    <app-footer></app-footer>
  </div>
</template>

<script>
import Navbar from '@/components/comps/Navbar.vue'
import Footer from '@/components/comps/Footer.vue'
import router from "@/plugins/router";
import axios from "axios";
import config from "../../config.json";
import templates from '@/assets/templates.json'
import values from '@/assets/values.json'

export default {
  name: "Home",
   mounted() {
    this.checkLoggedIn();
  },
  created() {
    this.mainloading=true;
    this.user=this.$session.get('user');
    axios({
      method : 'get',
      url: config.api.baseurl+'/api/vendeurs',
      headers: {'Authorization': 'JWT ' + this.$session.get('token')},
    }).then(response => {
      let vendors = response.data;
      vendors.sort((a,b)=>{return a.display_name.localeCompare(b.display_name)});
      this.vendeurs = vendors;
      this.mainloading=false;
      this.updateDisplayedVendors();
    }).catch(e => {
      console.error(e)
    })
  },
  components: {
    'app-navbar' : Navbar,
    'app-footer' : Footer,
  },
  methods: {
     checkLoggedIn() {
      this.$session.start();
      if (!this.$session.has("token")) {
        router.push("/auth");
      }else{
         axios({
          method : 'get',
          url : config.api.baseurl+'/api/user',
          headers: {'Authorization': 'JWT ' + this.$session.get('token')},
        })
        .then(response => {
          this.$session.set('user',response.data);
        }).catch(e=> {
          router.push("/auth");
          console.error(e);
        });
      }
    },
    updateDisplayedVendors(){
      console.log(this.search)
      if(this.search.length===0){
        this.displayedVendors=[...this.vendeurs];
      }else{
        this.displayedVendors=[...this.vendeurs.filter(e=>{ return (
           (e.nom+" "+e.prenom).toUpperCase().replaceAll(' ',"").includes(this.search.toUpperCase().replaceAll(' ',"")) 
           || (e.prenom+" "+e.nom).toUpperCase().replaceAll(' ',"").includes(this.search.toUpperCase().replaceAll(' ',"")))
        })];
      }
      console.log(this.displayedVendors)
    },
    saveEdit(){
      //update vendeur
      //replace vendeur in array by finding by id 
      if(this.$refs.form.validate()){
        this.loading = true;
        if(this.vendeur.id){
          //update
          axios({
            method : 'PUT',
            url : config.api.baseurl+'/api/update-vendeur/'+this.vendeur.id,
            headers: {'Authorization': 'JWT ' + this.$session.get('token')},
            data: this.vendeur
          })
          .then(response => {
            let updatedVendor=response.data;
            this.vendeur=updatedVendor;
            this.vendeurs.splice(this.vendeurs.findIndex(e=>e.id===this.vendeur.id), 1 , this.vendeur);
            this.loading=false;
            this.edit=false;
            this.updateDisplayedVendors();
          }).catch(e=> {
            console.error(e);
            this.loading=false;
            this.edit=false;
          });
        }else{
          //create
          axios({
            method : 'post',
            url : config.api.baseurl+'/api/create-vendeur',
            headers: {'Authorization': 'JWT ' + this.$session.get('token')},
            data: this.vendeur
          })
          .then(response => {
            let updatedVendor=response.data;
            this.vendeur=updatedVendor;
            this.vendeurs.splice(0,0,this.vendeur);
            this.loading=false;
            this.edit=false;
            this.updateDisplayedVendors();
          }).catch(e=> {
            console.error(e);
            this.loading=false;
            this.edit=false;

          });
        }
      }
    },
    deleteVendeur(id){
      console.log(id)
      axios({
            method : 'delete',
            url : config.api.baseurl+'/api/delete-vendeur/'+id,
            headers: {'Authorization': 'JWT ' + this.$session.get('token')},
          })
          .then(response => {
            this.vendeurs.splice(this.vendeurs.findIndex(e=>e.id===id), 1);
            this.updateDisplayedVendors();
             this.loading=false;
            this.edit=false;
            this.vendeurDialog=false;
            this.vendeur=null;
          }).catch(e=> {
            console.error(e);
            this.loading=false;
            this.edit=false;
            
            alert("impossible de supprimer ce vendeur car il a un bien associé")
          });
    },
    closeDialog(){
      this.vendeurDialog=false;
    },
    openVendeurDialog(vendeurToDisplay){
      console
        if(vendeurToDisplay==null){
            const vendeur_template=templates['vendeur'];
            this.vendeur = Object.create(vendeur_template);
            this.vendeurDialog=true;
            this.edit=true;
        }else{
            this.vendeur={...vendeurToDisplay};
            this.vendeurDialog=true;
        }
    },
  },
  watch: {
    search: function () {
        if (this.time) {
            clearTimeout(this.time);
        }
        this.time = setTimeout( () => this.updateDisplayedVendors(), 500);
    },
  },
   data() {
    return{
      vendeurDialog:false,
      edit:false,
      creation:false,
      user:null,
      vendeurs:null,
      vendeur: null,
      loading: false,
      inputRules:{
        isNotNull:[v=> v!=="" && v!==undefined && v!==null|| 'Information manquante'],
        isLongEnough:[v=> v.length>10 || "La description doit faire au moins 10 caractères" ]
      },
      values: values,
      search: "",
      query:"",
      displayedVendors:[],
      time: null,
    }
  },
}
</script>
<style>

  .link{
    text-decoration: none;
  }
  .vendeur{
    padding: 10px;
    cursor: pointer;
  }
</style>